import { createFileRoute } from '@tanstack/react-router';

import { CalculationSettingsPage } from '@/features/settings/CalculationSettingsPage';

export const Route = createFileRoute('/admin/_app/platform-settings/calculation')({
  component: CalculationSettingsPage,
});
